import React, {useState, useEffect} from 'react';
import {useCookies, withCookies} from 'react-cookie';
import {Checkbox} from '@homeaway/react-form-components';
import './Dnsmpi.less';

const COOKIE_NAME = 'dnsmpi';
const COOKIE_VALUE = 'true';
const COOKIE_MAX_AGE = 31536000;
const COOKIE_PATH = '/';
const COOKIE_VERSION = '1';
const applePrivacyLinkText =
    'For Apple privacy settings you may manage your preferences here';

const getCookieOptions = (domain) => {
    const cookieOptions = {
        path: COOKIE_PATH,
        maxAge: COOKIE_MAX_AGE,
        version: COOKIE_VERSION,
    };

    if (process.env.NODE_ENV !== 'development') {
        cookieOptions.domain = domain;
    }

    return cookieOptions;
};

const callAudiencePixelActivity = () => {
    const endpoint = `https://pubads.g.doubleclick.net/activity;dc_iu=/23171577/DFPAudiencePixel;ord=${Math.random()};dc_seg=907193633`;
    const isLoggedIn =
        ((window.analyticsdatalayer && window.analyticsdatalayer.publicuuid) ||
            '-1') !== '-1';

    if (isLoggedIn && process.env.NODE_ENV !== 'development') {
        fetch(endpoint, {mode: 'no-cors'}).catch((err) => err);
    }
};

const callBexDnsmpi = (canSell) => {
    const endpoint = `/dnsmpi/api/savePreference?canSell=${canSell}`;
    fetch(endpoint, {method: 'POST', mode: 'no-cors'}).catch((err) => err);
};

// eslint-disable-next-line complexity
const Dnsmpi = ({title, subtitle, checkboxLabel, terms, domain}) => {
    const [cookies, setCookie, removeCookie] = useCookies([COOKIE_NAME]);
    const cookieOptions = getCookieOptions(domain);
    const [iOSWebView, setiOSWebView] = useState(false);
    const [userAskedAppNotToTrack, setUserAskedAppNotToTrack] = useState(false);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        setUserAskedAppNotToTrack(params.get('iOSLinkEnabled') === 'true');
        const userAgent = window.navigator.userAgent;
        setiOSWebView(
            userAgent.includes('app.webview') || userAgent.includes('ios'),
        );
    });

    useEffect(() => {
        setChecked(cookies.dnsmpi === 'true');
    }, [cookies.dnsmpi]);

    function handleCheckboxChange(event) {
        const isCheckboxChecked = event.target.checked;

        if (isCheckboxChecked) {
            setCookie(COOKIE_NAME, COOKIE_VALUE, cookieOptions);
            callAudiencePixelActivity();
        } else {
            removeCookie(COOKIE_NAME, cookieOptions);
        }

        setChecked(isCheckboxChecked);

        window.edap.trigger('ccpa_preferences.updated', {
            ccpa_preference: `DO_NOT_SELL:${isCheckboxChecked}`,
        });
        callBexDnsmpi(!isCheckboxChecked);
    }

    return (
        <div className="container">
            <div className="Dnsmpi">
                <h1 className="Dnsmpi__title">{title}</h1>
                <p className="Dnsmpi__subtitle">{subtitle}</p>
                <div className="Dnsmpi__content">
                    <Checkbox
                        className="Dnsmpi__checkbox"
                        name="dnsmpiCheckbox"
                        label={checkboxLabel}
                        checked={
                            checked || (iOSWebView && userAskedAppNotToTrack)
                        }
                        disabled={iOSWebView && userAskedAppNotToTrack}
                        onChange={handleCheckboxChange}
                    />
                    {iOSWebView && userAskedAppNotToTrack && (
                        <p>
                            <a
                                className="apple-privacy"
                                href="expda://systemSettings"
                            >
                                {applePrivacyLinkText}
                            </a>
                        </p>
                    )}
                    <p className="Dnsmpi__terms">{terms}</p>
                </div>
            </div>
        </div>
    );
};

export default withCookies(Dnsmpi);
